var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.522-223.978q-19.236 0-32.249-12.996-13.012-12.995-13.012-32.206 0-19.211 13.174-32.385t32.326-13.174h80.717q19.236 0 32.249 13.174 13.012 13.174 13.012 32.385t-13.174 32.206q-13.174 12.996-32.326 12.996h-80.717ZM278.087-434.739q-19.236 0-32.249-12.996-13.012-12.995-13.012-32.206 0-19.211 13.012-32.385 13.013-13.174 32.249-13.174h403.587q19.236 0 32.248 13.174 13.013 13.174 13.013 32.385t-13.013 32.206q-13.012 12.996-32.248 12.996H278.087ZM157.13-645.5q-19.236 0-32.248-12.996-13.013-12.995-13.013-32.206 0-19.211 13.174-32.385t32.327-13.174h645.5q19.236 0 32.248 13.174 13.013 13.174 13.013 32.385t-13.174 32.206Q821.783-645.5 802.63-645.5h-645.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5260c849f6b2949c192558d075e4f438.svg";
export { ForwardRef as ReactComponent };